import { render, staticRenderFns } from "./onePlusSix.vue?vue&type=template&id=95326f3c&scoped=true&"
import script from "./onePlusSix.vue?vue&type=script&lang=js&"
export * from "./onePlusSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95326f3c",
  null
  
)

export default component.exports